<template>
  <el-upload
    class="avatar-uploader"
    :http-request="httpRequest"
    action=""
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    :disabled="isDisabled"
  >
    <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
    <div slot="trigger">
      <div class="trigger" v-if="show === 'card'">
        <i class="iconfont iconwenjianjia"></i>
        <div>{{ msg }}</div>
        <div class="schedule" v-if="isDisabled">
          <el-progress
            :percentage="percentage"
            :show-text="false"
          ></el-progress>
        </div>
      </div>
      <el-button size="small" type="primary" v-if="show === 'button'">
        <span class="el-icon-loading" v-if="isDisabled"></span>
        本地上传
      </el-button>
      <div v-if="show === 'else'">
        <slot></slot>
      </div>
    </div>
  </el-upload>
</template>

<script>
import OSS from "ali-oss";
import { $getUploadParams } from "@api/configcenter/file/manage.js";
export default {
  data() {
    return {
      imageUrl: "",
      isDisabled: false,
      percentage: 0
    };
  },
  props: {
    show: {
      default: "card"
    },
    fileType: {
      // 文件后缀名组成数组即可
      default: () => []
    },
    maxSize: {
      // 文件大小，以MB为单位
      default: 0
    },
    msg: {
      default: "添加附件"
    }
  },
  methods: {
    handleAvatarSuccess: function() {
      // debugger;
    },
    beforeAvatarUpload: function(file) {
      const fileExt = this.$utils.extname(file.name);
      let isType = true;
      let isSize = true;
      if (this.fileType.length) {
        isType = this.fileType.some(res => {
          return res.toLocaleLowerCase() === fileExt.toLocaleLowerCase();
        });
      }
      if (!isType) {
        this.$notify({
          type: "warning",
          message: "请上传正确的文件类型"
        });
      }
      if (this.maxSize) {
        isSize = file.size / 1024 / 1024 <= this.maxSize;
        this.$notify({
          type: "warning",
          message: "上传文件过大"
        });
      }
      return isType && isSize;
    },
    httpRequest(file) {
      this.isDisabled = true;
      const that = this;
      let StrName = file.file.name;
      const uuid = this.$utils.uuidGenerator();
      const ext = this.$utils.extname(StrName);
      const fileNew = new File([file.file], uuid + "." + ext);
      const params = {
        fileInfo: fileNew,
        schedule: this.getSchedule
      };
      this.upload(params)
        .then(
          res => {
            if (StrName.length > 20) {
              StrName.substring(0, 20);
            }
            if (StrName.length > 25) {
              StrName =
                StrName.substring(0, 13) +
                "..._" +
                StrName.substring(StrName.length - 8);
            }
            const imgdata = {
              name: res.name,
              desc: StrName
            };
            that.$emit("upload-success", imgdata, StrName);
          },
          err => {
            console.log(err);
          }
        )
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isDisabled = false;
          this.percentage = 0;
        });
    },
    upload: function(params) {
      let { fileInfo, domintype } = params;
      domintype = domintype || "gjy-authcenter";
      const _this = this;
      return new Promise(function(resolve, reject) {
        _this.getOssToken(fileInfo, domintype, resolve, reject);
      });
    },
    disposeParams: function(fileInfo, domintype) {
      const fileSuffix = fileInfo.name.split(".")[1];
      const params = {
        fileSuffix: fileSuffix,
        domintype: domintype
      };
      return params;
    },
    getOssToken: function(fileInfo, domintype, resolve, reject) {
      const params = this.disposeParams(fileInfo, domintype);
      const size = this.fileSize(fileInfo.size);
      $getUploadParams(params).then(
        res => {
          if (res.status === "0") {
            var client = new OSS({
              accessKeyId: res.accessKeyId,
              accessKeySecret: res.accessKeySecret,
              stsToken: res.securityToken,
              region: res.region,
              bucket: res.bucketName
            });
            fileInfo = new File([fileInfo], res.objectName);
            switch (size) {
              case "bigfile":
                this.multipartUpload(client, fileInfo, resolve, reject);
                break;
              case "smallfile":
                this.put(client, fileInfo, resolve, reject);
                break;
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    fileSize: function(size) {
      if (size / 1024 / 1024 >= 10) {
        return "bigfile";
      } else {
        return "smallfile";
      }
    },
    async put(client, fileInfo, resolve, reject) {
      try {
        const result = await client.put(fileInfo.name, fileInfo);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    },
    async multipartUpload(client, fileInfo, resolve, reject) {
      const _this = this;
      try {
        const result = await client.multipartUpload(fileInfo.name, fileInfo, {
          progress: _this.progress,
          meta: {
            year: 2020,
            people: "test"
          }
        });
        resolve(result);
      } catch (e) {
        // 捕获超时异常
        console.log(e);
        if (e.code === "ConnectionTimeoutError") {
          console.log("Woops,超时啦!");
        }
        reject(e);
      }
    },
    async progress(p) {
      this.percentage = p * 100;
    }
  }
};
</script>

<style lang="scss">
.trigger {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 236 * $toRem;
  height: 130 * $toRem;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  opacity: 1;
  border-radius: 8px;
  line-height: 1;
  color: #85a7ff;
  .iconfont {
    margin-bottom: 10 * $toRem;
    color: #85a7ff;
    font-size: 25 * $toRem;
  }
  .schedule {
    position: absolute;
    left: 10%;
    bottom: 20 * $toRem;
    width: 80%;
  }
}
/deep/.el-upload-list.el-upload-list--picture {
  display: inline-block;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 236px;
  height: 130px;
}
/* .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
} */
</style>
